import { forEach } from 'lodash';

export const createXmlHttpRequest = ({ method, url, headers }) => {
  const request = new XMLHttpRequest();

  try {
    request.responseType = 'json'; // IE11 doesn't support responseType json
  } catch (error) {}

  request.open(method, url);
  forEach({ 'Content-Type': 'application/json', ...headers }, (value, header) =>
    request.setRequestHeader(header, value),
  );

  return request;
};
